export default "__VITE_ASSET__DuVlli2y__"